import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=15d0680a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d0680a')) {
      api.createRecord('15d0680a', component.options)
    } else {
      api.reload('15d0680a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=15d0680a&", function () {
      api.rerender('15d0680a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/comp/IncreaseNumber.vue"
export default component.exports